import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M38.671 4C26.9101 4 17.3419 13.5682 17.3419 25.329C17.3419 30.6202 19.2794 35.4669 22.481 39.1987L19.9671 41.7126L17.6471 39.3925L5.43922 51.6004C3.52026 53.5194 3.52026 56.6417 5.43922 58.5608C7.35818 60.4796 10.4805 60.4799 12.3996 58.5608L24.6075 46.3529L22.2873 44.033L24.8012 41.5191C28.5331 44.7207 33.3798 46.6581 38.671 46.6581C50.4318 46.6581 60 37.0899 60 25.329C60 13.5682 50.4318 4 38.671 4ZM10.0792 56.2406C9.43956 56.8802 8.39903 56.8802 7.75938 56.2406C7.11984 55.601 7.11984 54.5603 7.75938 53.9208L17.647 44.0333L19.9667 46.353L10.0792 56.2406ZM38.671 43.3767C28.7195 43.3767 20.6233 35.2805 20.6233 25.329C20.6233 15.3776 28.7195 7.28139 38.671 7.28139C48.6224 7.28139 56.7186 15.3776 56.7186 25.329C56.7186 35.2805 48.6224 43.3767 38.671 43.3767Z",
      fill: "#002565"
    }, null, -1),
    _createElementVNode("path", {
      d: "M38.671 10.5627C30.5289 10.5627 23.9048 17.1869 23.9048 25.329C23.9048 33.4711 30.5289 40.0953 38.671 40.0953C46.8132 40.0953 53.4373 33.4711 53.4373 25.329C53.4373 17.1869 46.8132 10.5627 38.671 10.5627ZM38.671 36.8139C32.3383 36.8139 27.1862 31.6618 27.1862 25.329C27.1862 18.9962 32.3383 13.8441 38.671 13.8441C45.0038 13.8441 50.1559 18.9962 50.1559 25.329C50.1559 31.6618 45.0038 36.8139 38.671 36.8139Z",
      fill: "#002565"
    }, null, -1),
    _createElementVNode("path", {
      d: "M41.9525 19.7274L38.6711 23.0088L35.3897 19.7274L33.0693 22.0477L36.3507 25.3291L33.0693 28.6105L35.3897 30.9307L38.6711 27.6494L41.9525 30.9307L44.2728 28.6105L40.9914 25.3291L44.2728 22.0477L41.9525 19.7274Z",
      fill: "#002565"
    }, null, -1)
  ])))
}
export default { render: render }